<script lang="ts">
    import Modal, { createModal } from '$components/Modal.svelte';
    import { onMount } from 'svelte';
    import { melt } from '@melt-ui/svelte';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();
    export let resolve: (value: boolean | PromiseLike<boolean>) => void;
    export let id: string;
    export let title = t.ui.confirmation({}, $lang);
    export let message: string;

    const cancelButtonId = `${id}-cancel-button-id`;

    const modal = createModal({
        defaultOpen: false,
        openFocus: `#${cancelButtonId}`,
        onOpenChange({ next }) {
            if (!next) {
                resolve(false);
            }
            return next;
        },
    });

    const {
        elements: { title: titleElement, close: closeElement },
        states: { open },
    } = modal;

    onMount(() => {
        const timeoutId = setTimeout(() => {
            $open = true;
        }, 1);

        return () => clearTimeout(timeoutId);
    });

    function close(value: boolean) {
        resolve(value);
    }
</script>

<Modal
    contentClass="text-left max-w-[90vw] min-w-[60vw] t:max-w-[900px] t:min-w-[600px]"
    dialogClass="p-0 items-start"
    {modal}
>
    <div class="px-8 pt-12">
        <button
            use:melt={$closeElement}
            class="btn-reset text-21 font-bold text-black opacity-20 hover:opacity-80 absolute top-3 right-6"
        >
            <span aria-hidden="true">&times;</span>
        </button>
        <h4
            use:melt={$titleElement}
            class="m-0 text-18 ls:text-22 border-b border-gray-300"
        >
            {title}
        </h4>
    </div>

    <div class="text-left text-gray-600 px-8 py-8">
        {message}
    </div>

    <div class="px-8 py-6 flex items-center justify-end gap-4 bg-gray-100">
        <button use:melt={$closeElement} id={cancelButtonId} class="btn btn-default">
            {t.ui.cancel({}, $lang)}
        </button>
        <button type="button" on:click={() => close(true)} class="btn btn-danger">
            {t.ui.confirm({}, $lang)}
        </button>
    </div>
</Modal>
